'use es6';

import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Table } from 'foundations-components/transitional/components/Table';
import { Map as ImmutableMap } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getReportDashboardInfo, getName, getId } from '../../../data/schemas/reportSchema';
import { useDashboards } from '../../../data/hooks/useDashboards';
import DashboardCountCell from './DashboardCountCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hydrateDashboardInfoWithLastViewedAt = (reportDashboardInfo, dashboards) => {
  return reportDashboardInfo.map(dashboardInfo => {
    const lastViewedAt = dashboards === null || dashboards === void 0 ? void 0 : dashboards.getIn([dashboardInfo.get('id'), 'lastViewedAt']);
    return dashboardInfo.set('lastViewedAt', lastViewedAt);
  });
};
const ReportsTable = ({
  reports
}) => {
  const {
    data: dashboardsData,
    loading: dashboardsLoading
  } = useDashboards();
  const dashboards = dashboardsData === null || dashboardsData === void 0 ? void 0 : dashboardsData.get('dashboards');
  const reportListInfoMap = useMemo(() => {
    if (dashboardsLoading) {
      return null;
    }
    return ImmutableMap(reports.reduce((reportMap, report) => {
      reportMap[getId(report)] = hydrateDashboardInfoWithLastViewedAt(getReportDashboardInfo(report), dashboards);
      return reportMap;
    }, {}));
  }, [reports, dashboards, dashboardsLoading]);
  const TableRow = ({
    report
  }) => {
    const reportId = getId(report).toString();
    return /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: getName(report)
      }), reportListInfoMap && /*#__PURE__*/_jsx(DashboardCountCell, {
        parentDashboards: reportListInfoMap.get(reportId)
      })]
    });
  };
  return /*#__PURE__*/_jsx(ScrollContainer, {
    maxHeight: 300,
    children: /*#__PURE__*/_jsxs(Table, {
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reporting-action-components.actions.delete.modal.table.reportName"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reporting-action-components.actions.delete.modal.table.dashboards"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: reports.map(report => {
          return /*#__PURE__*/_jsx(TableRow, {
            report: report
          }, `parent-dashboard-${getId(report)}`);
        })
      })]
    })
  });
};
ReportsTable.propTypes = {
  reports: ImmutablePropTypes.set.isRequired
};
export default ReportsTable;